import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss', './radio-grouped.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent implements ControlValueAccessor {
  @Input() value: boolean | string;
  @Input() name: string;
  @Input() grouped? = false;

  onChange: (_: boolean | string) => void;
  onTouched: () => void;

  model: boolean | string;

  disabled: boolean;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  registerOnChange(fn: (_: boolean | string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  writeValue(value: boolean | string): void {
    this.model = value;
    this.cdr.detectChanges();
  }

  doChange(event: Event, label: HTMLLabelElement): void {
    label.click();
    label.focus();
    event.preventDefault();
  }
}
